<!--首页 站点前十排行-->
<template>
    <div ref="siteRankEcharts" style="width:95%;height:95%" class="center" />
</template>

<script>
import { mapState } from "vuex";
import Public from "@/public";
var echarts = require("echarts");
export default {
    data() {
        return {
            orderSummaryDatas: [],
            yAxisData: [],
            seriesMoney: [],
            seriesPower: [],
            orderCount: [],
            chart: null,
        };
    },
    computed: {
        ...mapState(["theme", "siteOrderSummary"]),
    },
    watch: {
        siteOrderSummary: {
            handler(val) {
                this.orderSummaryDatas = JSON.parse(JSON.stringify(val));
                this.yAxisData = [];
                this.seriesMoney = [];
                this.seriesPower = [];
                this.orderCount = [];
                this.dealData(this.orderSummaryDatas);
            },
            deep: true,
        },
    },
    mounted() {
        this.chart = echarts.init(this.$refs.siteRankEcharts);
    },
    methods: {
        dataEcharts() {
            this.chart.setOption({
                title: {
                    text: "站点排行",
                    left: "5%",
                    textStyle: {
                        color: this.theme.pageFontColor,
                    },
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: ["电量", "金额", "订单数"],
                    top: 30,
                    textStyle: {
                        fontWeight: "normal",
                        fontSize: 12,
                        color: this.theme.pageFontColor,
                    },
                },
                grid: {
                    // left: "2%",
                    // right: "6%",
                    // bottom: "8%",
                    containLabel: true,
                },
                toolbox: {
                    right: "5%",
                    show: true,
                    feature: {
                        saveAsImage: { show: true },
                    },
                },
                calculable: true,
                xAxis: [
                    {
                        type: "value",
                        boundaryGap: [0, 0.01],
                        axisLine: {
                            show: true,
                        },
                        min: 0,
                    },
                ],
                yAxis: [
                    {
                        type: "category",
                        data: this.yAxisData,
                        axisLabel: {
                            align: "right",
                            verticalAlign: "middle",
                            lineHeight: 56,
                            textStyle: {
                                fontSize: "13",
                                color: "black",
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "电量",
                        type: "bar",
                        data: this.seriesPower,
                        label: {
                            show: true,
                            position: "inside",
                        },
                        emphasis: {
                            focus: "series",
                        },
                    },
                    {
                        name: "金额",
                        type: "bar",
                        data: this.seriesMoney,
                        label: {
                            show: true,
                            position: "inside",
                        },
                        emphasis: {
                            focus: "series",
                        },
                    },
                    {
                        name: "订单数",
                        type: "bar",
                        data: this.orderCount,
                        label: {
                            show: true,
                            position: "inside",
                        },
                        emphasis: {
                            focus: "series",
                        },
                    },
                ],
            });
        },
        dealData(orderSummaryDatas) {
            if (!orderSummaryDatas) {
                return;
            }
            // orderSummaryDatas.sort(Public.createComprisonFunction("power"));
            if (orderSummaryDatas.length > 10) {
                orderSummaryDatas.slice(0, 10);
            }
            for (let i = 0; i < orderSummaryDatas.length; i++) {
                this.seriesMoney.push(orderSummaryDatas[i].money.toFixed(2));
                this.seriesPower.push(orderSummaryDatas[i].power.toFixed(2));
                this.orderCount.push(orderSummaryDatas[i].order_count);
                this.yAxisData.push(orderSummaryDatas[i].name);
            }
            this.dataEcharts();
        },
    },
};
</script>

<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
